module.exports = __webpack_public_path__ + "static/media/maharashtra.73b81daa.png";